<template>
  <div class="container">
    <div class="section">
      <title-bar title="Certificados" class="title-bar"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue')
  },
  data () {
    return {
      loading: true,
      menu: []

    }
  },
  methods: {
    ...mapActions([])
  },
  computed: {

  },
  created () {

  }

}
</script>

<style lang="scss" scoped>
.section {
  padding-top: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
